import { blinkConstants } from '@thoughtspot/blink-constants';
import { normalizeBase64String } from '@thoughtspot/codec-util';
import { isOrgsOnFTEnabled } from '@thoughtspot/feature-service';
import { translate as t } from '@thoughtspot/i18n';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { CellType } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import { getAccessToken, getAllGroupGUID, getCurrentOrgId, getGuidsToSkip, getSubscriptionType, getTSAdminUserGuid, getUserGuid, getUserPrivileges, getWhiteListedEmailDomainsForReport, hasAdminPrivileges, hasUserAdminPrivileges, isEnhancedUserEmailValidationEnabled, isMfaEnabled, isOrgUiEnabled, isPrincipalImportExportEnabled, isRolesEnabled, isScriptabilityEnabled, resetPasswordV2Enabled, shouldShowWhiteListedDomains, SubscriptionType, } from '@thoughtspot/session-service';
import { getIdpDomain, isOktaEnabled, } from '@thoughtspot/system-config-service';
import _ from 'lodash';
import React from 'react';
import { downloadFileUtil } from "../../../utils/file-download.util";
import { MoreOptions } from '../more-options/more-options';
import { MODE } from '../util';
import styles from './users.module.scss';
export const zipFileExt = '.zip';
export const appType = 'application/x-yaml';
export const tslFileExt = '.tml';
export const zipType = 'application/zip';
export const user = 'USER';
export const ON_CHANGE_DELAY = 300;
export const USER_NAME_MAX_LENGTH = 64;
export const USER_DISPLAY_NAME_MAX_LENGTH = 124;
export const USER_NAME_WITH_DOMAIN_MAX_LENGTH = 100;
export const getUserNameMaxLength = () => {
    const idpDomain = getIdpDomain();
    if (!idpDomain) {
        return USER_NAME_WITH_DOMAIN_MAX_LENGTH;
    }
    const maxLength = USER_NAME_WITH_DOMAIN_MAX_LENGTH - (idpDomain.length + 1);
    return maxLength > 0 ? maxLength : 1;
};
export var UserStatus;
(function (UserStatus) {
    UserStatus["INACTIVE"] = "INACTIVE";
    UserStatus["PENDING"] = "PENDING";
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["LOCKED"] = "LOCKED";
    UserStatus["SUSPENDED"] = "SUSPENDED";
    UserStatus["EXPIRED"] = "EXPIRED";
})(UserStatus || (UserStatus = {}));
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["DONE"] = "Done";
    TranslationsKeys["SAVE"] = "Save";
    TranslationsKeys["CANCEL"] = "Cancel";
    TranslationsKeys["BACK"] = "Back";
    TranslationsKeys["LOADING"] = "LOADING_MSG";
    TranslationsKeys["DELETE"] = "DELETE";
    TranslationsKeys["RESET_PASSWORD"] = "reset.password";
    TranslationsKeys["PAGE_TITLE"] = "metadataListPage.users.title";
    TranslationsKeys["COL_HEADER_GROUP_NAME"] = "groups.colHeader.groupName";
    TranslationsKeys["ADD_USER_BUTTON_TITLE"] = "users.list.modal.addUser";
    TranslationsKeys["DISPLAY_NAME"] = "adminUI.captions.DISPLAYED_NAME";
    TranslationsKeys["USERNAME"] = "adminUI.captions.USERNAME";
    TranslationsKeys["MODAL_OK"] = "modal.ok";
    TranslationsKeys["CREATED"] = "metadataListPage.captions.CREATED";
    TranslationsKeys["TAB_CREATE_CREDENTIALS"] = "users.modalTabLinkLabel.createCredentials";
    TranslationsKeys["TAB_EDIT_CREDENTIALS"] = "users.modalTabLinkLabel.editCredentials";
    TranslationsKeys["FIELDS_GROUP_NAME_DESC"] = "groups.modalFieldsLabel.groupNameAndDescription";
    TranslationsKeys["REVIEW_SELECTION"] = "roles.modal.reviewSelection";
    TranslationsKeys["FIELDS_ALLOW_OTHERS_TO_SHARE"] = "users.modalFieldsLabel.allowOthersToShare";
    TranslationsKeys["ADD_SUCCESS_MSG"] = "msg_code.1203.summary";
    TranslationsKeys["UPDATE_MULTIPLE_SUCCESS_MSG"] = "msg_code.12078.summary";
    TranslationsKeys["UPDATE_SUCCESS_MSG"] = "msg_code.1207.summary";
    TranslationsKeys["DELETE_SUCCESS_MSG"] = "msg_code.1215.summary";
    TranslationsKeys["RESET_MFA_MSG"] = "msg_code.990707.summary";
    TranslationsKeys["RESET_MFA_ERROR_MSG"] = "err_code.990707.summary";
    TranslationsKeys["DISPLAY_NAME_REQUIRED"] = "groups.modalFieldsLabel.formFieldsRequired.fieldDisplayName";
    TranslationsKeys["NAME_REQUIRED"] = "users.modalFieldsLabel.formFieldsRequired.fieldName";
    TranslationsKeys["MODAL_FORM_NAME_MAX_LIMIT"] = "roles.modal.formFields.validName.maxLimit";
    TranslationsKeys["MODAL_FORM_FIELD_CHAR_LIMIT"] = "groups.modal.formFields.validField.charLimit";
    TranslationsKeys["MODAL_FORM_DESC_MAX_LIMIT"] = "roles.modal.formFields.validDescription.maxLimit";
    TranslationsKeys["CLEAR"] = "Clear";
    TranslationsKeys["SELECT_ALL"] = "smartCheckboxCollection.SELECT_ALL_ITEMS";
    TranslationsKeys["SHOW_SELECTED"] = "autoWorksheet.selectedItemsToggle.SHOW_SELECTED";
    TranslationsKeys["SHARING"] = "groups.modalFieldsLabel.reviewScreen.sharing";
    TranslationsKeys["CHILD_GROUP"] = "groups.modalFieldsLabel.reviewScreen.childGroup";
    TranslationsKeys["ROLES_TITLE"] = "roles.pageTitle";
    TranslationsKeys["COL_HEADER_MORE_OPTIONS"] = "roles.colHeader.moreOptions";
    TranslationsKeys["MORE_OPTIONS_EDIT"] = "EDIT";
    TranslationsKeys["MORE_OPTIONS_DELETE"] = "DELETE";
    TranslationsKeys["CONFIRM_DELETE"] = "CONFIRM_DELETE";
    TranslationsKeys["DELETE_BODY"] = "alert.USER_DELETE_DIALOG_MESSAGE_SINGULAR";
    TranslationsKeys["DELETE_BODY_PLURAL"] = "alert.USER_DELETE_DIALOG_MESSAGE_PLURAL";
    TranslationsKeys["EMAIL"] = "adminUI.captions.EMAIL";
    TranslationsKeys["PASSWORD"] = "adminUI.captions.CREATE_PASSWORD";
    TranslationsKeys["NEW_PASSWORD"] = "adminUI.captions.PASSWORD";
    TranslationsKeys["CONFIRM_PASSWORD"] = "adminUI.captions.PASSWORD_CONFIRMATION";
    TranslationsKeys["EDIT_MODAL_TITLE"] = "users.list.modal.editUser";
    TranslationsKeys["CREATE_MODAL_TITLE"] = "users.list.modal.addUser";
    TranslationsKeys["SEND_EMAIL_LABEL"] = "adminUI.captions.SEND_EMAIL_LABEL";
    TranslationsKeys["SEND_MESSAGE_PLACEHOLDER"] = "adminUI.captions.SEND_MESSAGE_PLACEHOLDER";
    TranslationsKeys["TEST_WELCOME_EMAIL"] = "adminUI.captions.WELCOME_EMAIL";
    TranslationsKeys["PASSWORD_NOT_MATCHING"] = "users.modalFieldsLabel.formFieldsRequired.confirmPasswordNotMatching";
    TranslationsKeys["PASSWORD_REQUIREMENT_NOT_MATCHING"] = "users.modalFieldsLabel.formFieldsRequired.passwordRequirementNotMatching";
    TranslationsKeys["PASSWORD_REQUIRED"] = "users.modalFieldsLabel.formFieldsRequired.passwordLabel";
    TranslationsKeys["CONFIRM_PASSWORD_REQUIRED"] = "users.modalFieldsLabel.formFieldsRequired.confirmPassword";
    TranslationsKeys["EMAIL_REQUIRED"] = "users.modalFieldsLabel.formFieldsRequired.labelEmail";
    TranslationsKeys["NOT_WHITELISTED_EMAIL"] = "users.modalFieldsLabel.formFieldsRequired.emailNotValid";
    TranslationsKeys["SHOW_WHITELISTED_DOMAINS"] = "whiteListedDomainsText";
    TranslationsKeys["STATUS"] = "metadataListPage.captions.ACCOUNT_ACTIVATION";
    TranslationsKeys["SELECTED_GROUPS"] = "adminUI.captions.MANAGE_GROUPS_TAB";
    TranslationsKeys["SELECTED_ORGS"] = "adminUI.captions.ORGS_TAB";
    TranslationsKeys["ADD_USERS_TO_GROUPS"] = "users.list.modal.ADD_TO_GROUPS";
    TranslationsKeys["ADD_USERS_TO_GROUPS_TITLE"] = "users.list.modal.ADD_TO_GROUPS";
    TranslationsKeys["IMPORT_USER_TITLE"] = "users.list.importUserTitle";
    TranslationsKeys["EXPORT"] = "EXPORT";
    TranslationsKeys["SEND"] = "Send";
    TranslationsKeys["EMAIL_RESEND_CONFIRMATION"] = "adminUI.captions.EMAIL_RESEND_CONFIRMATION";
    TranslationsKeys["ADMIN_EMAIL_SENT_CONFIRMATION"] = "adminUI.captions.ADMIN_EMAIL_SENT_CONFIRMATION";
    TranslationsKeys["ORGS_NOT_SELECTED"] = "adminSection.userManagement.errors.selectAtLeastOneOrg";
    TranslationsKeys["ADD_USERS_TO_ORG"] = "adminUI.tooltip.ADD_USER_TO_ORG";
    TranslationsKeys["PASSWORD_REQUIREMENTS_TITLE"] = "freetrial.passwordrequirement.title";
    TranslationsKeys["ADD"] = "Add";
    TranslationsKeys["EXPORT_LIMIT_ERROR"] = "principal.export.error.maxLimit";
    TranslationsKeys["RESET_MFA"] = "users.moreOptions.resetMFA";
    TranslationsKeys["RESET_PASSWORD_CONFIRMATION"] = "users.confirm.reset";
    TranslationsKeys["OTP_USAGE"] = "users.confirm.otp.press";
    TranslationsKeys["OTP_WARNING"] = "otp.warning";
    TranslationsKeys["EXPIRE_PASSWORD"] = "expire.password";
    TranslationsKeys["OTP_GENERATION_FAILED"] = "otp.failed";
    TranslationsKeys["RE_INVITE_SUCCESS_MSG"] = "adminUI.messages.ACTIVATION_MAIL_SENT_SUCCESS";
    TranslationsKeys["RE_INVITE_ERROR_MSG"] = "adminUI.messages.ACTIVATION_MAIL_SENT_ERROR";
})(TranslationsKeys || (TranslationsKeys = {}));
export const getPasswordRequirementsLabel = () => {
    return [
        ['length', 'upper', 'lower'],
        ['digit', 'special_character'],
    ];
};
export var ListActionType;
(function (ListActionType) {
    ListActionType["EDIT"] = "edit";
    ListActionType["DELETE"] = "delete";
    ListActionType["EXPORT"] = "export";
    ListActionType["ADD_USERS_TO_GROUPS"] = "addUsersToGroups";
    ListActionType["RESEND_ACTIVATION_MAIL"] = "resendActivationMail";
    ListActionType["UNLOCK"] = "unlockUser";
    ListActionType["UNSUSPEND"] = "unsuspendUser";
    ListActionType["RESET_MFA"] = "resetMFA";
    ListActionType["RESET_PASSWORD"] = "resetPassword";
})(ListActionType || (ListActionType = {}));
export var tableColumnHeaders;
(function (tableColumnHeaders) {
    tableColumnHeaders["USER_NAME"] = "userName";
    tableColumnHeaders["USER_DISPLAY_NAME"] = "userDisplayName";
    tableColumnHeaders["USER_CREATED"] = "userCreated";
    tableColumnHeaders["USER_STATE"] = "userState";
    tableColumnHeaders["MORE_OPTION"] = "moreOption";
})(tableColumnHeaders || (tableColumnHeaders = {}));
export const sortKeyMap = {
    [tableColumnHeaders.USER_DISPLAY_NAME]: 'DISPLAY_NAME',
    [tableColumnHeaders.USER_NAME]: 'NAME',
    [tableColumnHeaders.USER_CREATED]: 'CREATED',
    [tableColumnHeaders.USER_STATE]: 'USER_STATE',
};
const oldEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const newEmailRegex = /^[a-zA-Z0-9\u0080-\uFFFF._%+!#$&'*/=?^`{|}~-]+@[a-zA-Z0-9\u0080-\uFFFF.-]+\.[a-zA-Z]{2,}$/u;
export const validEmailRegex = isEnhancedUserEmailValidationEnabled()
    ? newEmailRegex
    : oldEmailRegex;
const getValidationRules = () => {
    return [
        {
            id: 'length',
            regex: /(?=.{8,})/,
        },
        {
            id: 'lower',
            regex: /(?=.*[a-z])/,
        },
        {
            id: 'upper',
            regex: /(?=.*[A-Z])/,
        },
        {
            id: 'special_character',
            regex: /[-!$%^&*()_+|~=`'"\\{}\[\]:\/;<>?,.@#]/,
        },
        {
            id: 'digit',
            regex: /(?=.*\d)/,
        },
    ];
};
export const checkValidationRules = (password) => {
    let isValid = true;
    getValidationRules().forEach((rule) => {
        if (!rule.regex.test(password)) {
            isValid = false;
        }
    });
    return isValid;
};
const ActionLinks = ({ links }) => (React.createElement(Horizontal, { className: styles.mainActionLinks }, links.map((link) => (React.createElement(Link, { key: link.id, className: styles.actionLink, onClick: link.onClick }, link.label)))));
export const generateMoreOption = (context, data) => {
    let isEditDisabled = false;
    if (data.id === getTSAdminUserGuid() &&
        getUserGuid() !== getTSAdminUserGuid()) {
        isEditDisabled = true;
    }
    const editOption = {
        title: 'Group1',
        items: [
            {
                id: ListActionType.EDIT,
                label: t(TranslationsKeys.MORE_OPTIONS_EDIT),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.EDIT,
                        data,
                    });
                },
                itemDisabled: isEditDisabled,
            },
        ],
    };
    const exportOption = {
        title: 'Group2',
        items: [
            {
                id: ListActionType.EXPORT,
                label: t(TranslationsKeys.EXPORT),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.EXPORT,
                        data,
                    });
                },
            },
        ],
    };
    const deleteOption = {
        title: 'Group3',
        items: [
            {
                id: ListActionType.DELETE,
                label: t(TranslationsKeys.MORE_OPTIONS_DELETE),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.DELETE,
                        data,
                    });
                },
                itemDisabled: data.id === getUserGuid() ||
                    data.id === getTSAdminUserGuid(),
            },
        ],
    };
    const mfaResetOption = {
        title: 'Group4',
        items: [
            {
                id: ListActionType.RESET_MFA,
                label: t(TranslationsKeys.RESET_MFA),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.RESET_MFA,
                        data,
                    });
                },
            },
        ],
    };
    const resetPasswordOption = {
        title: 'Group5',
        items: [
            {
                id: ListActionType.RESET_PASSWORD,
                label: t(TranslationsKeys.RESET_PASSWORD),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.RESET_PASSWORD,
                        data,
                    });
                },
            },
        ],
    };
    if (isPrincipalImportExportEnabled() && isScriptabilityEnabled()) {
        if (isMfaEnabled()) {
            return [
                editOption,
                exportOption,
                deleteOption,
                mfaResetOption,
                ...(resetPasswordV2Enabled() ? [resetPasswordOption] : []),
            ];
        }
        return [
            editOption,
            exportOption,
            deleteOption,
            ...(resetPasswordV2Enabled() ? [resetPasswordOption] : []),
        ];
    }
    if (isMfaEnabled() && isOktaEnabled()) {
        return [
            editOption,
            deleteOption,
            mfaResetOption,
            ...(resetPasswordV2Enabled() ? [resetPasswordOption] : []),
        ];
    }
    return [
        editOption,
        deleteOption,
        ...(resetPasswordV2Enabled() ? [resetPasswordOption] : []),
    ];
};
export const generateUserStateOption = (context, data) => {
    const { userState } = data;
    let option;
    switch (userState.text) {
        case UserStatus.PENDING:
            option = {
                id: ListActionType.RESEND_ACTIVATION_MAIL,
                label: t('oktaUser.RESEND_ACTIVATION_MAIL'),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.RESEND_ACTIVATION_MAIL,
                        data,
                    });
                },
            };
            break;
        case UserStatus.LOCKED:
            option = {
                id: ListActionType.UNLOCK,
                label: t('oktaUser.UNLOCK'),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.UNLOCK,
                        data,
                    });
                },
            };
            break;
        case UserStatus.SUSPENDED:
            option = {
                id: ListActionType.UNSUSPEND,
                label: t('oktaUser.UNSUSPEND'),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.UNSUSPEND,
                        data,
                    });
                },
            };
            break;
        default:
            break;
    }
    return option ? [option] : [];
};
const UserDisplayNameEle = ({ userDisplayName, }) => {
    return (React.createElement(Vertical, null,
        React.createElement(Horizontal, { className: styles.userDisplayName },
            React.createElement(Typography, { variant: "p", overrideTag: "div", color: Colors.base, ellipsis: { rows: 1 }, tooltipConfig: {
                    showTooltipOnlyOnEllipsis: true,
                    dataTooltipAlign: 'center',
                    dataTooltipContent: userDisplayName,
                } }, userDisplayName))));
};
export const UserNameEle = ({ data, context }) => {
    const name = data[tableColumnHeaders.USER_NAME].text;
    const elementProps = {
        variant: 'p',
        overrideTag: 'div',
        children: name,
        ellipsis: { rows: 1 },
        tooltipConfig: {
            showTooltipOnlyOnEllipsis: true,
            dataTooltipAlign: 'center',
            dataTooltipContent: name,
        },
    };
    if (!data.readOnly) {
        elementProps.color = Colors.accent;
        elementProps.className = styles.userName;
        elementProps.onClick = () => {
            context.onRowAction({
                action: ListActionType.EDIT,
                data,
            });
        };
    }
    return (React.createElement("div", { className: styles.userNameWrapper },
        React.createElement(Vertical, null,
            React.createElement(Typography, { ...elementProps }))));
};
const UserStateEle = ({ userState }) => {
    return (React.createElement(Horizontal, { className: styles.userState },
        React.createElement(Typography, { variant: "p", overrideTag: "div", color: Colors.base, ellipsis: { rows: 1 }, tooltipConfig: {
                showTooltipOnlyOnEllipsis: true,
                dataTooltipAlign: 'center',
                dataTooltipContent: userState,
            } }, userState)));
};
export const DEFAULT_PAGINATION_BATCHSIZE = 20;
export const isFreeTrialOrTeamOrDeveloperUser = () => {
    const subscriptionType = getSubscriptionType();
    return (!!subscriptionType &&
        (subscriptionType === SubscriptionType.TEAMS_EDITION ||
            subscriptionType === SubscriptionType.FREE_TRIAL ||
            subscriptionType === SubscriptionType.DEVELOPER_EDITION));
};
export const getColumnDefinitions = () => {
    return [
        {
            cellRendererFramework: (params) => {
                return React.createElement(UserNameEle, { ...params });
            },
            headerName: t(TranslationsKeys.COL_HEADER_GROUP_NAME),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.USER_NAME,
            suppressMovable: true,
            sortable: true,
            initialSort: 'asc',
            flex: 2,
        },
        {
            cellRendererFramework: (params) => {
                const { userDisplayName } = params.data;
                return (React.createElement(UserDisplayNameEle, { userDisplayName: userDisplayName.text }));
            },
            headerName: t(TranslationsKeys.DISPLAY_NAME),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.USER_DISPLAY_NAME,
            suppressMovable: true,
            flex: 2,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t(TranslationsKeys.CREATED),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.USER_CREATED,
            suppressMovable: true,
            sortable: true,
            flex: 1,
        },
        ...(isOktaEnabled()
            ? [
                {
                    cellRendererFramework: (params) => {
                        const { context, data } = params;
                        const { userState } = data;
                        const links = generateUserStateOption(context, data);
                        return (React.createElement(Vertical, null,
                            React.createElement(UserStateEle, { userState: userState.text }),
                            (userState.text === 'PENDING' ||
                                userState.text === 'LOCKED' ||
                                userState.text === 'SUSPENDED') && (React.createElement(ActionLinks, { links: links }))));
                    },
                    headerName: t(TranslationsKeys.STATUS),
                    headerClass: [styles.headerStyle],
                    colId: tableColumnHeaders.USER_STATE,
                    suppressMovable: true,
                    flex: 2,
                },
            ]
            : []),
        ...(!isOktaEnabled() && isFreeTrialOrTeamOrDeveloperUser()
            ? [
                {
                    cellRendererFramework: (params) => {
                        const { context, data } = params;
                        const { userState } = data;
                        if (userState.text === UserStatus.INACTIVE) {
                            userState.text = UserStatus.PENDING;
                        }
                        const links = generateUserStateOption(context, data);
                        return (React.createElement(Vertical, { className: styles.userStatusWrapper },
                            React.createElement(UserStateEle, { userState: userState.text }),
                            (userState.text === UserStatus.PENDING ||
                                userState.text === UserStatus.LOCKED ||
                                userState.text ===
                                    UserStatus.SUSPENDED) && (React.createElement(ActionLinks, { links: links }))));
                    },
                    headerName: t(TranslationsKeys.STATUS),
                    headerClass: [styles.headerStyle],
                    colId: tableColumnHeaders.USER_STATE,
                    suppressMovable: true,
                    flex: 2,
                },
            ]
            : []),
        {
            cellRenderer: (params) => {
                const { context, data } = params;
                if (data.readOnly) {
                    return null;
                }
                return (React.createElement(MoreOptions, { menuId: 1, menuLabel: t(TranslationsKeys.COL_HEADER_MORE_OPTIONS), menuItemGroups: generateMoreOption(context, data), isDisabled: data.isChecked }));
            },
            colId: tableColumnHeaders.MORE_OPTION,
            headerName: '',
            headerClass: [styles.headerStyle, styles.moreHeaderStyle],
            sortable: false,
            width: 50,
            suppressMovable: true,
        },
    ];
};
export const userParams = {
    sort: 'NAME',
    sortAscending: true,
    batchSize: DEFAULT_PAGINATION_BATCHSIZE,
    offset: 0,
    pattern: '',
    category: 'ALL',
    skipIds: getGuidsToSkip(),
};
export const TAB_LABEL_ID = {
    SELECT_GROUPS: 'selectGroups',
    SELECT_ORGS: 'selectOrgs',
};
export const createEditTabLinkLabels = (isEditMode, currentOrgId) => {
    if (isOktaEnabled()) {
        if (isOrgUiEnabled() && currentOrgId === -1) {
            return ['createCredentials', 'selectOrgs'];
        }
        return ['createCredentials', 'selectGroups'];
    }
    if (isOrgUiEnabled() && currentOrgId === -1) {
        if (isEditMode) {
            return ['editCredentials', 'selectOrgs'];
        }
        return ['createCredentials', 'selectOrgs'];
    }
    if (isEditMode) {
        return ['editCredentials', 'selectGroups', 'resendWelcomeEmail'];
    }
    return ['createCredentials', 'selectGroups', 'sendWelcomeEmail'];
};
export const hasCreateEditInputError = (hasInputError, form, isEditMode, untouchedFields) => {
    const { displayName, name, password, confirmPassword, email } = form;
    let isNameRequired = false;
    let isNameLong = false;
    let isDisplayNameRequired = false;
    let isDisplayNameLong = false;
    let arePasswordsNotMatching = false;
    let isPasswordEmpty = false;
    let isConfirmPasswordEmpty = false;
    let isPasswordValidationRuleFailed = false;
    let isEmailEmpty = false;
    let isNotWhitelistedDomainEmail = false;
    let isNameEmailNotSame = false;
    if (!untouchedFields.isNameUntouched && _.isEmpty(name)) {
        isNameRequired = true;
    }
    if (!untouchedFields.isDisplayNameUntouched && _.isEmpty(displayName)) {
        isDisplayNameRequired = true;
    }
    if (name.length > getUserNameMaxLength()) {
        isNameLong = true;
    }
    if (displayName.length > USER_DISPLAY_NAME_MAX_LENGTH) {
        isDisplayNameLong = true;
    }
    if (!untouchedFields.isPasswordUntouched &&
        !untouchedFields.isConfirmPasswordUntouched &&
        !isOktaEnabled() &&
        password !== confirmPassword) {
        arePasswordsNotMatching = true;
    }
    if (!untouchedFields.isPasswordUntouched &&
        !isOktaEnabled() &&
        !isEditMode &&
        _.isEmpty(password)) {
        isPasswordEmpty = true;
    }
    if (!untouchedFields.isConfirmPasswordUntouched &&
        !isOktaEnabled() &&
        !isEditMode &&
        _.isEmpty(confirmPassword)) {
        isConfirmPasswordEmpty = true;
    }
    const isNewPasswordValid = isEditMode
        ? _.isEmpty(password) || checkValidationRules(password)
        : checkValidationRules(password);
    if (!untouchedFields.isPasswordUntouched &&
        !isOktaEnabled() &&
        !isNewPasswordValid) {
        isPasswordValidationRuleFailed = true;
    }
    if (!untouchedFields.isEmailUntouched && !isEditMode && _.isEmpty(email)) {
        isEmailEmpty = true;
    }
    const whitelistedDomainList = getWhiteListedEmailDomainsForReport();
    const emailDomain = email.split('@')[1];
    const ignoreEmailValidation = whitelistedDomainList.length === 1 && whitelistedDomainList[0] === '*';
    if (!untouchedFields.isEmailUntouched &&
        (!validEmailRegex.test(email) ||
            (!ignoreEmailValidation &&
                (emailDomain === email ||
                    !whitelistedDomainList.includes(emailDomain))))) {
        isNotWhitelistedDomainEmail = true;
    }
    if (isOrgsOnFTEnabled() &&
        (hasAdminPrivileges() || (isRolesEnabled() && hasUserAdminPrivileges()))) {
        if (name !== email) {
            isNameEmailNotSame = true;
        }
    }
    return {
        ...hasInputError,
        isDisplayNameRequired,
        isDisplayNameLong,
        isNameRequired,
        isNameLong,
        arePasswordsNotMatching,
        isPasswordEmpty,
        isConfirmPasswordEmpty,
        isPasswordValidationRuleFailed,
        isNotWhitelistedDomainEmail,
        isEmailEmpty,
        isNameEmailNotSame,
    };
};
export const getInputLabelColor = (hasError) => {
    const { isDisplayNameRequired, isDisplayNameLong, isNameRequired, isNameLong, } = hasError;
    return (isDisplayNameRequired ||
        isDisplayNameLong ||
        isNameRequired ||
        isNameLong);
};
export const getInputLabel = (hasError, translate, isDisplayName = false) => {
    if (hasError.isDisplayNameRequired && isDisplayName) {
        return translate(TranslationsKeys.DISPLAY_NAME_REQUIRED);
    }
    if (hasError.isDisplayNameLong && isDisplayName) {
        return translate(TranslationsKeys.MODAL_FORM_FIELD_CHAR_LIMIT, {
            field_name: translate(TranslationsKeys.DISPLAY_NAME),
            char_limit: USER_DISPLAY_NAME_MAX_LENGTH,
        });
    }
    if (hasError.isNameRequired && !isDisplayName) {
        return translate(TranslationsKeys.NAME_REQUIRED);
    }
    if (hasError.isNameLong && !isDisplayName) {
        return translate(TranslationsKeys.MODAL_FORM_FIELD_CHAR_LIMIT, {
            field_name: translate(TranslationsKeys.USERNAME),
            char_limit: getUserNameMaxLength(),
        });
    }
    return isDisplayName
        ? translate(TranslationsKeys.DISPLAY_NAME)
        : translate(TranslationsKeys.USERNAME);
};
export const getPasswordInputLabel = (hasError, translate, isConfirmPassword = false) => {
    if (hasError.isPasswordEmpty && !isConfirmPassword) {
        return translate(TranslationsKeys.PASSWORD_REQUIRED);
    }
    if (hasError.isPasswordValidationRuleFailed && !isConfirmPassword) {
        return translate(TranslationsKeys.PASSWORD_REQUIREMENT_NOT_MATCHING);
    }
    if (hasError.isConfirmPasswordEmpty && isConfirmPassword) {
        return translate(TranslationsKeys.CONFIRM_PASSWORD_REQUIRED);
    }
    if (hasError.arePasswordsNotMatching && isConfirmPassword) {
        return translate(TranslationsKeys.PASSWORD_NOT_MATCHING);
    }
    return isConfirmPassword
        ? translate(TranslationsKeys.CONFIRM_PASSWORD)
        : translate(TranslationsKeys.PASSWORD);
};
export const getEmailInputLabel = (hasError, translate) => {
    if (hasError.isEmailEmpty) {
        return translate(TranslationsKeys.EMAIL_REQUIRED);
    }
    if (hasError.isNotWhitelistedDomainEmail) {
        return translate(TranslationsKeys.NOT_WHITELISTED_EMAIL);
    }
    return translate(TranslationsKeys.EMAIL);
};
export const getWhitelistedDomainsText = (hasError) => {
    if (shouldShowWhiteListedDomains()) {
        const whitelistedDomainList = getWhiteListedEmailDomainsForReport();
        const whitelistedDomains = whitelistedDomainList.join(', ');
        const { isEmailEmpty, isNotWhitelistedDomainEmail } = hasError;
        if (!isEmailEmpty && isNotWhitelistedDomainEmail) {
            return whitelistedDomains;
        }
        const helperText = t(TranslationsKeys.SHOW_WHITELISTED_DOMAINS) + whitelistedDomains;
        return helperText;
    }
    return null;
};
export const getToastMessage = (scenario, usersCount) => {
    if (scenario === MODE.ADD) {
        return t(TranslationsKeys.ADD_SUCCESS_MSG);
    }
    if (scenario === MODE.UPDATE) {
        return t(TranslationsKeys.UPDATE_SUCCESS_MSG);
    }
    if (scenario === MODE.DELETE) {
        return t(TranslationsKeys.DELETE_SUCCESS_MSG);
    }
    if (scenario === MODE.ASSIGN_USERS_GROUPS) {
        if (usersCount > 1) {
            return t(TranslationsKeys.UPDATE_MULTIPLE_SUCCESS_MSG);
        }
        return t(TranslationsKeys.UPDATE_SUCCESS_MSG);
    }
    if (scenario === MODE.ASSIGN_USERS_ORG) {
        return t(TranslationsKeys.UPDATE_SUCCESS_MSG);
    }
    if (scenario === MODE.RESET_MFA) {
        return t(TranslationsKeys.RESET_MFA_MSG);
    }
    if (scenario === MODE.RESEND_ACTIVATION) {
        return t(TranslationsKeys.RE_INVITE_SUCCESS_MSG);
    }
    return null;
};
export const isFieldDisabledForMultipleOrgs = (currentOrgId, modal) => {
    if (modal?.header.id === getTSAdminUserGuid() &&
        currentOrgId !== blinkConstants.orgs.ALL_ID &&
        getCurrentOrgId() !== blinkConstants.orgs.MASTER_ID) {
        return true;
    }
    return (isOrgUiEnabled() &&
        currentOrgId !== blinkConstants.orgs.ALL_ID &&
        (modal?.header.orgIds.length > 1 || modal?.header.belongToAllOrgs));
};
export const COUNT_LABELS = {
    SELECTED_ORGS: 'SELECTED_ORGS',
    SELECTED_GROUPS: 'SELECTED_GROUPS',
};
export const getSelectedCount = (record, type) => {
    if (type === COUNT_LABELS.SELECTED_GROUPS &&
        record.has(getAllGroupGUID())) {
        return record.size - 1;
    }
    return record.size;
};
export const roleListParams = {
    sortascending: true,
    batchsize: -1,
    offset: 0,
    pattern: '',
};
export const orgListParams = {
    sortascending: true,
    batchsize: -1,
    offset: 0,
    pattern: '',
    sort: 'DEFAULT',
};
const downloadFile = (epack, customFileName, containsMultipleObjects, shouldExportDependencies) => {
    const objects = epack.object;
    let type = '';
    let blobContent;
    let fileName = customFileName;
    if (containsMultipleObjects || shouldExportDependencies) {
        const normalized = normalizeBase64String(epack.zipFile);
        const buffer = new Uint8Array(Array.from(atob(normalized), (c) => c.charCodeAt(0)));
        blobContent = buffer;
        fileName += zipFileExt;
        type = zipType;
    }
    else {
        blobContent = objects[0].edoc;
        fileName += tslFileExt;
        type = appType;
    }
    downloadFileUtil({
        blob: new Blob([blobContent], { type }),
        fileName,
    });
};
export const downloadExportedUsers = (epack, shouldExportDependencies, customName) => {
    const objects = epack.object;
    const containsMultipleObjects = objects.length > 1;
    let fileName = '';
    if (containsMultipleObjects) {
        fileName = customName || user;
    }
    else {
        const suffix = user.toLocaleLowerCase();
        fileName = `${customName ||
            objects[0].name ||
            objects[0].id}.${suffix}`;
    }
    downloadFile(epack, fileName, containsMultipleObjects, shouldExportDependencies);
};
export const getDefaultSamlHeaders = () => {
    return {
        accessToken: `Bearer ${getAccessToken()}`,
        xTsPrivileges: btoa(JSON.stringify(getUserPrivileges())),
        xTsIdpDomain: getIdpDomain(),
    };
};
export const hasImplicitAdminAccess = (isSuperUser, isCurrentUser) => {
    return isSuperUser || (isCurrentUser && hasAdminPrivileges());
};
//# sourceMappingURL=util.js.map